import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function BackButton({ step, setStep, onBack }) {
  if (step === 0) return null;

  const handleBack = () => {
    setStep(prev => Math.max(0, prev - 1));
    if (onBack) {
      onBack();
    }
  };

  return (
    <button className="lp-back-btn" type="button" onClick={handleBack}>
      <FontAwesomeIcon icon={faArrowLeft} style={{ marginLeft: "1px" }} />
    </button>
  );
}
